import { WebPlugin } from '@capacitor/core';
export class DatePickerWeb extends WebPlugin {
    present(_options) {
        throw new Error('Method not implemented.');
    }
}
//# sourceMappingURL=web.js.map